export const environment = {
  production: true,
  errorReportingApiKey: 'AIzaSyDXmrJVVcmMLdfgjae-vHv0L9LaVVtiE6A',
  errorReportingUrl: 'https://clouderrorreporting.googleapis.com/v1beta1/projects/onya-ci-cd/events:report',
  releaseDate: '',
  matomoId: 3,
};
